const setting = {
    title: '中国一汽招聘',
    domain: 'https://faw-zhaopin.hotjob.cn',
    suiteKey: 'SU603374380dcad4635b836531',
    suiteKeyMc: 'SU62d7ff10bef57c58929dbfdb',
    ClientId: 'yiqi-web',
    platform: '2',
    grayscale: false,   // 黑白风格
}

export default setting